// extracted by mini-css-extract-plugin
module.exports = {"slide":"Slider_slide__3N5nK","intro":"Slider_intro__5k5ed","logo":"Slider_logo__60Ll5","animate":"Slider_animate__I6zRS"};